import {
  type ComponentProps,
  type ComponentType,
  forwardRef,
  ReactNode,
} from 'react';
import { NavLink, NavLinkProps } from 'react-router';
import cl from 'clsx';

import classes from './Button.module.scss';

export type ButtonLinkProps = Omit<NavLinkProps, 'children'> & {
  PrefixIcon?: ComponentType<ComponentProps<'svg'>>;
  SuffixIcon?: ComponentType<ComponentProps<'svg'>>;
  variant: 'primary' | 'secondary';
  children: ReactNode;
};

export const ButtonLink = forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  function ButtonLink(
    {
      type = 'button',

      PrefixIcon,
      SuffixIcon,
      variant,

      children,
      className,

      ...rest
    },
    ref,
  ) {
    return (
      <NavLink
        type={type}
        ref={ref}
        className={cl(classes.root, classes[variant], className)}
        {...rest}
      >
        {PrefixIcon && <PrefixIcon className={classes.icon} />}
        {children}
        {SuffixIcon && <SuffixIcon className={classes.icon} />}
      </NavLink>
    );
  },
);
